import React, { useState } from 'react'
import logo from '../../assets/images/favicon.png'
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as CheckoutAction from '../../redux/actions/CheckoutAction'
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../constant/routes';
import Loading from '../common/Loading';
import axios from 'axios';
import { IMAGE } from '../../redux/apis/Api';

export default function RazorpayBtn(props) {
    const dispatch = useDispatch()
    const { createOrder } = bindActionCreators(CheckoutAction, dispatch)
    console.log(props)
    const navigation = useNavigate()
    const [loader, setLoader] = useState(false)

    const loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = 'https://checkout.razorpay.com/v1/checkout.js';
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    const displayRazorpay = async () => {
        const res = await loadRazorpayScript();


        setLoader(true)
        const userObj = {
            user_id: props?.user_id,
            total_amount: props?.total_amount,
            cgst_amount: props?.cgst_amount,
            sgst_amount: props?.sgst_amount,
            total_gst_amount: props?.total_gst_amount,
            address_id: props?.address_id,
            promocode_id: props?.promocode_id,
            discount_price: props?.discount_price,
            paid_amount: Number(props?.paid_amount),
            shipping_price: props?.shipping_price,
            promocode_discount_price: props?.promocode_discount_price,
            payment_id: ""
        }

        try {
            const resData = await axios.post(`${IMAGE}api/generate_payu_hash/`, userObj)

            console.log("resData", resData)



            const form = document.createElement("form");
            form.method = "POST";
            // form.action = "https://test.payu.in/_payment"; // Production: https://secure.payu.in/_payment
            form.action = "https://secure.payu.in/_payment"; // Production: https://secure.payu.in/_payment

            const fields = {
                key: resData?.data?.key,
                txnid: resData?.data.txnid,
                amount: resData?.data?.amount,
                productinfo: resData?.data?.productinfo,
                firstname: resData?.data?.firstname,
                email: resData?.data?.email,
                phone: resData?.data?.mobile,
                surl: `${IMAGE}api/payu_payment_verify/`,
                furl: `${IMAGE}api/payu_payment_verify/`,
                hash: resData?.data?.data,
            };

            Object.keys(fields).forEach((key) => {
                const input = document.createElement("input");
                input.type = "hidden";
                input.name = key;
                input.value = fields[key];
                form.appendChild(input);
            });

            document.body.appendChild(form);
            form.submit();


        } catch (error) {
            console.log(error)
        }


        // const resData = await createOrder(userObj)
        // console.log("resData", resData)
        // if (resData?.statuscode == 200) {
        //     setLoader(false)

        //     navigation(ROUTES.paymentSuccess, { state: "response" })
        // }
        // else {
        //     alert("Error in api")
        // }



        // if (!res) {
        //     alert('Razorpay SDK failed to load. Are you online?');
        //     return;
        // }

        // const options = {
        //     key: 'rzp_test_fqG41B7WsgUsNX',  // Add your Razorpay key ID here
        //     amount: Number(props?.paid_amount) * 100,  // Amount is in paise (50000 paise = 500 INR)
        //     currency: 'INR',
        //     name: 'H N Store',
        //     description: 'Transaction for placing an order',
        //     image: logo,  // Optional: add your logo here
        //     handler: async function (response) {
        //         console.log(response);

        //     },
        //     prefill: {
        //         name: 'Harshil Patel',
        //         email: 'pharshil5603@gmail.com',
        //         contact: '9104592065',
        //     },
        //     theme: {
        //         color: '#299e60',
        //     },
        // };

        // const paymentObject = new window.Razorpay(options);
        // paymentObject.open();
    };



    return (
        <div>
            <Loading open={loader} setOpen={setLoader} />

            <button
                disabled={props?.disabled}
                className="btn btn-main mt-40 py-18 w-100 rounded-8 mt-56"
                onClick={displayRazorpay}
            >
                {props?.title}
            </button>
        </div>
    )
}
